import { Component } from '@angular/core';
import {EcomanagerService} from '../ecomanager/Ecomanager.service';
import {I18NService} from '../../shared/i18n/i18n.service';
import {IPlaceValuelistService} from '../../iPlace/iPlace-valuelist.service';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {EcosensorLog} from './EcosensorLog';
import {EcosensorLogService} from './EcosensorLog.service';

@Component({
  templateUrl: './Ecosensor.component.html',
  styleUrls: ['./Ecosensor.component.css']
})
export class EcosensorComponent {

  hasCredentials = false;
  dropdownList: any = [];
  dropdownSettings: any = {};
  selectedItems: any = [];
  tableMessages: any;
  bsConfig: Partial<BsDatepickerConfig>;
  dateRangeFilter: any;
  isServiceLoading = true;
  isDataLoading = false;
  subscription: any;
  ecosensorLogItems: EcosensorLog[] = [];

  constructor(private ecomanagerService: EcomanagerService,  private i18nService: I18NService,
              private iPlaceValuelistService: IPlaceValuelistService, private ecosensorLogService: EcosensorLogService) {
    if (this.ecomanagerService.isLoaded()) {
      this.isServiceLoading = false;
      this.initConfig();
    } else {
      this.subscription = this.ecomanagerService.loadedChange$.subscribe( loaded => {
        this.isServiceLoading = !loaded;
        this.initConfig();
      });
    }
  }

  initConfig() {
    this.hasCredentials = this.ecomanagerService.getCredentialByServiceAndParam('ecosensor', 'username') != null
      && this.ecomanagerService.getCredentialByServiceAndParam('ecosensor', 'password') != null;
      if (this.hasCredentials) {
        this.setDropdownList();
        this.setDropDownSettings();
        this.setTableMessages();
        this.bsConfig = Object.assign({}, {containerClass: 'theme-custom', showWeekNumbers: false});
        this.setDateRangeFilter();
      }
  }

  setDropdownList() {
    if ( (<any>Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.dropdownList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a: any, b: any) => a.iPlaceName.localeCompare(b.iPlaceName));
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => this.dropdownList = (<any>Object).values(this.iPlaceValuelistService.getValuelist())
          .sort((a: any, b: any) => a.iPlaceName.localeCompare(b.iPlaceName)))
    }
  }

  setDropDownSettings() {
    this.dropdownSettings = {
      singleSelection: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: this.i18nService.get('selectAll'),
      unSelectAllText: this.i18nService.get('unselectAll'),
      filterSelectAllText: this.i18nService.get('selectAllFiltered'),
      filterUnSelectAllText: this.i18nService.get('unselectAllFiltered'),
      noDataLabel: this.i18nService.get('noResults'),
      text: this.i18nService.get('selectStation'),
      searchPlaceholderText: this.i18nService.get('search'),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      classes: 'form-angular2-multiselect'
    };
  }

  setTableMessages() {
    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get('noDataToDisplay');
    this.tableMessages.totalMessage = this.i18nService.get('total');
    this.tableMessages.selectedMessage = this.i18nService.get('selected');
  }

  setDateRangeFilter() {
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    this.dateRangeFilter = [date, date];
  }

  onItemSelect(item: any) {
    this.reloadEcosensorLogs();
  }

  onSelectAll(item: any) {
    this.reloadEcosensorLogs();
  }

  onDateRangeChange(any: any) {
    this.reloadEcosensorLogs();
  }

  reloadEcosensorLogs() {
    this.isDataLoading = true;
    let iPlaceIds = this.selectedItems.map(iplace => iplace.idiPlace)
      .join(';');
    let start = this.dateRangeFilter[0].getTime();
    let end = this.dateRangeFilter[1].getTime() + 86400000;

    this.ecosensorLogService.get(iPlaceIds, start, end)
      .then( list => {
        this.ecosensorLogItems = list;
        this.isDataLoading = false;
      })
      .catch( error => {
        this.isDataLoading = false;
      });
  }

}
